import gql from "@/api/gql"

const insurers = gql`
	query insurers {
		insurers {
			id
			name
		}
	}
`

const fileBuckets = gql`
	query fileBuckets($where: bucketWhereInput) {
		fileBuckets(where: $where) {
			bucketName
			providerId
		}
	}
`

const fileListing = gql`
	query fileListing($prefix: String, $bucketName: String, $sort: String, $skip: Int, $limit: Int) {
		fileListing(prefix: $prefix, bucketName: $bucketName, sort: $sort, skip: $skip, limit: $limit) {
			commonPrefixes
			objectSummaries {
				fileName
				key
				lastModifiedAt
				size
				isPublic
			}
		}
	}
`

const searchFiles = gql`
	query searchFiles($bucketName: String, $where: fileWhere) {
		searchFiles(bucketName: $bucketName, where: $where) {
			fileName
			isPublic
			key
			lastModifiedAt
			size
		}
	}
`

const createFolder = gql`
	mutation createFolder($key: String!) {
		createFolder(key: $key) {
			errors
			errors_2 {
				code
				message
			}
			status
		}
	}
`

const deleteFolder = gql`
	mutation deleteFolder($key: String!) {
		deleteFolder(key: $key) {
			errors
			errors_2 {
				code
				message
			}
			status
		}
	}
`

const deleteFile = gql`
	mutation deleteFile($key: String!) {
		deleteFile(key: $key) {
			errors
			errors_2 {
				code
				message
			}
			status
		}
	}
`

const moveFile = gql`
	mutation moveFile($key: String!, $newKey: String!) {
		moveFile(key: $key, newKey: $newKey) {
			errors
			errors_2 {
				code
				message
			}
			status
		}
	}
`

const setFileAcl = gql`
	mutation setFileAcl($isPublic: Boolean!, $key: String!) {
		setFileAcl(key: $key, isPublic: $isPublic) {
			errors
			status
			errors_2 {
				code
				message
			}
		}
	}
`

const copyFiles = gql`
	mutation copyFiles($copyFileInputs: [copyFileInput]!) {
		copyFiles(copyFileInputs: $copyFileInputs) {
			errors
			errors_2 {
				code
				message
			}
			status
		}
	}
`

const introspection = gql`
	query IntrospectionQuery {
		__schema {
			queryType {
				name
				description
				fields {
					name
					description
					args {
						...InputValue
					}
					type {
						...TypeRef
					}
				}
			}
			types {
				...FullType
			}
		}
	}

	fragment FullType on __Type {
		kind
		name
		description
		fields(includeDeprecated: true) {
			name
			description
			args {
				...InputValue
			}
			type {
				...TypeRef
			}
			isDeprecated
			deprecationReason
		}
		inputFields {
			...InputValue
		}
		interfaces {
			...TypeRef
		}
		enumValues(includeDeprecated: true) {
			name
			description
			isDeprecated
			deprecationReason
		}
		possibleTypes {
			...TypeRef
		}
	}

	fragment InputValue on __InputValue {
		name
		description
		type {
			...TypeRef
		}
		defaultValue
	}

	fragment TypeRef on __Type {
		kind
		name
		ofType {
			kind
			name
			ofType {
				kind
				name
				ofType {
					kind
					name
					ofType {
						kind
						name
						ofType {
							kind
							name
							ofType {
								kind
								name
								ofType {
									kind
									name
								}
							}
						}
					}
				}
			}
		}
	}
`

const createZipJob = gql`
	mutation zipJobMutationCreateZipJob($input: filesystem_CreateZipJobInput!) {
		zipJobMutationCreateZipJob(input: $input) {
			jobId
			status
			downloadUrl
			expiresAt
			errorMessage
		}
	}
`

const getZipJobStatus = gql`
	query zipJobQueryZipJob($id: String!) {
		zipJobQueryZipJob(id: $id) {
			jobId
			status
			downloadUrl
			errorMessage
			expiresAt
		}
	}
`

export const query = { insurers, fileBuckets, fileListing, searchFiles, introspection, getZipJobStatus }
export const mutation = { createFolder, deleteFolder, deleteFile, moveFile, setFileAcl, copyFiles, createZipJob }
